import React from 'react';

import * as S from './EmptyTemplateVariables.styles';

export const EmptyTemplateVariables = () => {
  return (
    <S.Container>
      <S.IconContainer>
        <S.CodeAltIcon size="large" />
      </S.IconContainer>
      <S.Header>No launch-time overrides</S.Header>
      <S.Text>
        Use the <S.varSpan>{'{{variable}}'}</S.varSpan> format and parse to
        create variables for override.
      </S.Text>
    </S.Container>
  );
};

export default EmptyTemplateVariables;
